import { Link } from 'react-router-dom';

export default function PagoPage() {
  const numeroWhatsApp = '51994964216';
  const mensajeWhatsApp = encodeURIComponent('Hola, ya realicé el pago de mi entrada para SOUL. Adjunto mi comprobante.');

  return (
    <div className="bg-black text-white min-h-screen">
      {/* Navegación */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm">
        <div className="px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="text-xl md:text-2xl font-bold tracking-wider cursor-pointer">
            SOUL
          </Link>
          
          <Link to="/" className="text-white/80 hover:text-white transition-colors text-xs md:text-sm tracking-wide flex items-center gap-2 cursor-pointer">
            <i className="ri-arrow-left-line"></i>
            <span className="hidden sm:inline">Volver al inicio</span>
            <span className="sm:hidden">Inicio</span>
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 md:mb-6">
            Compra tu entrada
          </h1>
          <p className="text-base md:text-xl text-[#CCCCCC] max-w-2xl mx-auto">
            Haz clic en el botón de abajo para acceder al formulario de compra y asegurar tu entrada para SOUL.
          </p>
        </div>
      </section>

      {/* Botón de compra */}
      <section className="py-8 md:py-16 px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-[#1A1A1A] border border-[#333] rounded-3xl p-8 md:p-12">
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-gradient-to-br from-[#A855F7] to-[#EC4899] rounded-full">
              <i className="ri-ticket-2-fill text-2xl md:text-3xl text-white"></i>
            </div>
            
            <p className="text-lg md:text-2xl text-white mb-3 md:mb-4 font-medium">
              Completa tu compra en nuestro formulario seguro
            </p>
            <p className="text-sm md:text-base text-[#999] mb-8 md:mb-10">
              Serás redirigido a la página de compra donde podrás completar tu pedido.
            </p>
            
            <a 
              href="https://pagos.soulfeelthenight.site/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 md:gap-3 bg-gradient-to-r from-[#A855F7] to-[#EC4899] hover:shadow-[0_0_40px_rgba(168,85,247,0.6)] text-white px-8 md:px-12 py-4 md:py-5 rounded-full text-base md:text-xl font-bold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-cart-line text-xl md:text-2xl"></i>
              <span>Ir al formulario de compra</span>
            </a>
          </div>
        </div>
      </section>

      {/* Instrucciones y WhatsApp */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-gradient-to-b from-transparent to-[#0A0A0A]">
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-[#1A1A1A] border border-[#333] rounded-3xl p-8 md:p-12">
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-gradient-to-br from-[#A855F7] to-[#EC4899] rounded-full">
              <i className="ri-send-plane-fill text-2xl md:text-3xl text-white"></i>
            </div>
            
            <p className="text-lg md:text-2xl text-white mb-3 md:mb-4 font-medium">
              ¿Necesitas ayuda con tu compra?
            </p>
            <p className="text-sm md:text-base text-[#999] mb-8 md:mb-10">
              Contáctanos por WhatsApp y te ayudaremos con cualquier duda.
            </p>
            
            <a 
              href={`https://wa.me/${numeroWhatsApp}?text=${mensajeWhatsApp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 md:gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-white px-8 md:px-12 py-4 md:py-5 rounded-full text-base md:text-xl font-bold transition-all hover:scale-105 hover:shadow-[0_0_40px_rgba(37,211,102,0.4)] whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
              <span className="hidden sm:inline">Contactar por WhatsApp</span>
              <span className="sm:hidden">Contactar</span>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-8 md:py-12 border-t border-[#1A1A1A]">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
            <Link to="/" className="text-lg md:text-xl font-bold cursor-pointer">SOUL</Link>
            <p className="text-xs text-[#555555]">SOUL © 2025</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
